import {CanOrder} from '../../CanOrder';
import {OnDestroy, OnInit} from '@angular/core';
import {AppStatus} from '../../@models/app-status';
import {ProductBase} from '../../../shared-gen/Model/Products/ProductBase';
import {Choice} from '../../../shared-gen/Model/Products/Choice';
import {VmcState} from '../../../shared-gen/Vending/Status/VmcState';
import {DeviceStatusFun} from '../../../shared/device/device-status.fun';
import {AppService} from '../../services/app.service';
import { formatIoCurrency } from "../../../shared/pipes/currency.pipe";

export class OptionsPageBase extends CanOrder implements OnInit, OnDestroy {

	product: ProductBase = null;
	details: { left: string, right: string } = {
		left: null,
		right: null
	};

	constructor(app: AppService) {
		super(app);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);

		if (!status.selectedProduct || !status.selectedProduct.ID || !(status.selectedProduct as ProductBase).Instances) {
			this.app.nav.openPageAndReportUserActivity(`/${this.theme}/menu/`);
			return;
		}

		this.product = status.selectedProduct as ProductBase;
		if (this.product.Details) {
			const sep = '<hr />';
			if (this.product.Details.includes(sep)) {
				const t = this.product.Details.split(sep);
				this.details.left = t[0];
				t.splice(0, 1);
				this.details.right = t.join(sep);
			}
		}

		this.cartMaximum = status.deviceStatus.UIConfig.CartItemsCount;

		if (!status.selectedProduct) // Do not recompute when page is closed
		{
			this.app.nav.openPageAndReportUserActivity(`/${this.theme}/menu/`);
			return;
		}
	}

	back() {
		this.app.status.setSelectedProduct(null);
	}

	hasInstanceOfChoice(choice: Choice) {
		return this.product.Instances.findIndex(it => it.ID === `${this.product.ID}-${choice.ID}`) !== -1;
	}

	getInstanceOfChoice(choice: Choice) {
		if (choice === null) {
			return this.product.Instances[0];
		}
		return this.product.Instances.find(it => it.ID === `${this.product.ID}-${choice.ID}`);
	}

	choiceAvailable(choice: Choice) {
		const product = this.getInstanceOfChoice(choice);
		return this.productIsAvailable(product);
	}

	orderByChoice(choice: Choice, event) {
		event.stopPropagation();
		this.reportActivity();
		//TODO wie funktionieren zukünftig verschachtelte optionen?
		const instance = this.getInstanceOfChoice(choice);
		if (!instance) {
			return false;
		}
		this.order(instance);
	}

	getPriceOfChoice(choice: Choice): string {
		let price = this.getPrice(this.getInstanceOfChoice(choice));
		return formatIoCurrency(price / 100, this.app.getCurrency());
	}

	choiceHasDeposit(choice: Choice): boolean {
		const instance = this.getInstanceOfChoice(choice);
		let deposit = this.getDeposit(instance);
		return deposit > 0;
	}

	getDepositOfChoice(choice: Choice): string {
		const instance = this.getInstanceOfChoice(choice);
		let deposit = this.getDeposit(instance);
		return formatIoCurrency(deposit / 100, this.app.getCurrency());
	}

	async reportActivity() {
		if (DeviceStatusFun.getVmcState(this.deviceStatus) === VmcState.Inactive) {
			console.log('reset inactive timer');
			await this.app.status.reportUserActivity();
		}
	}
}
